import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData, imgUrl } from '../Services/api';
const UserDetails = () => {
  const { id } = useParams();
  const [users, setUsers] = useState({});
  const fetchUserDetails = async () => {
    try {
      const res = await getData(`/users/user-details/${id}`);
      if (res.status) {
        setUsers(res.data || {});
      }
    } catch (error) {
      console.log("error fetch user details", error)
    }
  }
  useEffect(() => {
    if (id) {
      fetchUserDetails();
    }
  }, [id]);
  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/users/user-list">
                        Users</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      User Details
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">User Details</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="tab-content">
                <div className="row">
                  <div className="col-lg-4 col-xxl-3">
                    <div className="card">
                      <div className="card-body position-relative">
                        <div className="position-absolute end-0 top-0 p-3">
                          <span className="badge bg-primary text-capitalize">{users?.username}</span>
                        </div>
                        <div className="text-center mt-3">
                          <div className="chat-avtar d-inline-flex mx-auto">
                            <img
                              className="rounded-circle img-fluid wid-70"
                              src={users?.profileImage ? `${imgUrl}${users.profileImage}` : avtar5}
                              alt="User image"
                            />
                          </div>
                          <h5 className="mb-0">{users?.fullname}</h5>
                          <p className="text-muted text-sm">{users?.role}</p>
                          <hr className="my-3 border border-secondary-subtle" />
                          <div className="row g-3">
                            <div className="col-4">
                              <h5 className="mb-0">{users?.totalPosts}</h5>
                              <small className="text-muted">Post</small>
                            </div>
                            <div className="col-4 border border-top-0 border-bottom-0">
                              <h5 className="mb-0">{users?.totalFollowers}</h5>
                              <small className="text-muted">Followers</small>
                            </div>
                            <div className="col-4">
                              <h5 className="mb-0">{users?.totalFollowing}</h5>
                              <small className="text-muted">Following</small>
                            </div>
                          </div>
                          <hr className="my-3 border border-secondary-subtle" />
                          <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                            <i className="ti ti-mail me-2" />
                            <p className="mb-0">{users?.email}</p>
                          </div>
                          <div className="d-inline-flex align-items-center justify-content-start w-100 mb-3">
                            <i className="ti ti-phone me-2" />
                            <p className="mb-0">{users?.mobile}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-xxl-9">
                    <div className="card">
                      <div className="card-header">
                        <h5>Personal Details</h5>
                      </div>
                      <div className="card-body">
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item px-0 pt-0">
                            <div className="row">
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">Full Name</p>
                                <p className="mb-0">{users?.fullname}</p>
                              </div>
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">User Name</p>
                                <p className="mb-0">{users?.username}</p>
                              </div>
                            </div>
                          </li>
                          <li className="list-group-item px-0">
                            <div className="row">
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">Phone</p>
                                <p className="mb-0">{users?.mobile}</p>
                              </div>
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">Gender</p>
                                <p className="mb-0">{users?.gender}</p>
                              </div>
                            </div>
                          </li>
                          <li className="list-group-item px-0">
                            <div className="row">
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">Email</p>
                                <p className="mb-0">{users?.email}</p>
                              </div>
                              <div className="col-md-6">
                                <p className="mb-1 text-muted">Dob.</p>
                                <p className="mb-0">{users?.dob?.split('T')[0]}</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserDetails